/* eslint-disable indent */
export default function trackHeapLoadTime(loadTime) {
	if (!loadTime) {
		return false;
	}

	let group = '';

	switch (true) {
		case loadTime > 5 && loadTime <= 15:
			group = '>5'; break;
		case loadTime > 15 && loadTime <= 30:
			group = '>15';
			break;
		case loadTime > 30 && loadTime <= 60:
			group = '>30';
			break;
		case loadTime > 60 && loadTime <= 180:
			group = '>60';
			break;
		case loadTime > 180 && loadTime <= 300:
			group = '>180';
			break;
		case loadTime > 300:
			group = '>300';
			break;
		default:
			group = '<5';
			break;
	}

	window.Modalytics.heap('track', ['Heap Load Time', {
		heapLoadTime: loadTime,
		heapLoadTimeGroup: group
	}]);
}
